import React from 'react';
import styled from 'styled-components';

import { color as colors } from '@workboard/wobo-ui';

const SeparatorWrapper = styled.span`
  color: ${colors('--gray-600')};
  padding: ${({ theme }) => theme.spacing(1)}px;
`;

export interface IProps {
  separator?: string;
}

const Separator = ({ separator = '/' }: IProps): JSX.Element => (
  <SeparatorWrapper>{separator}</SeparatorWrapper>
);

Separator.defaultProps = { separator: '/' };

export default Separator;
